import { Loader } from "@googlemaps/js-api-loader";
import { useState, useEffect, useMemo } from "react";

export default function useGoogleMaps({ libraries }) {
    const [isGoogleMapsLoaded, setLoaded] = useState(false);
    const [loadError, setLoadError] = useState(undefined);
    const google = isGoogleMapsLoaded ?? window?.google;

    const loader = useMemo(() => {
        return new Loader({
            apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API,
            libraries
        });
    }, [libraries]);

    useEffect(() => {
        if (window?.google) {
            setLoaded(true);
        }

        if (!isGoogleMapsLoaded && !window?.google) {
            loader
                .load()
                .then(function then() {
                    setLoaded(true);
                })
                .catch(function onrejected(error) {
                    setLoadError(error);
                });
        }
    }, [isGoogleMapsLoaded, loader]);

    return { isGoogleMapsLoaded, loadError, google };
}
